import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { MoreVert, Check } from '@material-ui/icons';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
  PosPermission,
  useCheckPaymentCodeInUseQuery,
  useGetAssignedOutletByUserQuery,
  useGetOutletQuery,
  useGetTaxSchemeListingQuery,
  usePaymentCodeDeleteMutation,
  usePaymentCodeInActiveMutation,
  usePaymentCodeListingQuery,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { OutletIcon } from '../../../../../assets';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';


export const BankTTList = ({ mode}) => {
  useEffect(() => {
    console.log('BankTTList');
  }, []);
  const history = useHistory();
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
  const { snackFunc} = useSnackBar()
  const {filteredList, handleSearch, setOriginalListing } = useFuseSearch();
  const {
        filteredList: filteredList1,
        handleSearch: handleSearch1,
        setOriginalListing: setOriginalListing1,
      } = useFuseSearch();
  const { handlePermDisabled } = usePermissionChecker();
  const outletID = localStorage.getItem('latestOutlet');
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

    const {
      data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
      loading: taxSchemeListingLoading,
      refetch: reftechTaxSchemeListing,
    } = useGetTaxSchemeListingQuery({
      fetchPolicy: 'network-only',
      variables: {
        accountID: user?.accountID,
      },
    });
    

  const {
    data: { getAssignedOutletByUser } = { getAssignedOutletByUser: [] },
    loading: getAssignedOutletByUserLoading,
  } = useGetAssignedOutletByUserQuery({
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (getAssignedOutletByUser && getAssignedOutletByUser?.length > 0) {
      setOriginalListing1(getAssignedOutletByUser);
    }
  }, [getAssignedOutletByUser]);
  
    const {
    loading: listLoading,
    data: { PaymentCodeListing } = { PaymentCodeListing: [] },
    refetch,
  } = usePaymentCodeListingQuery({
    variables: {
      OutletID: outletID,
      PaymentMode: mode
    },
    fetchPolicy: 'no-cache',
  })
  
  useEffect(() => {
      if (PaymentCodeListing?.length > 0 && PaymentCodeListing) {
        setOriginalListing(PaymentCodeListing);
      }
    }, [PaymentCodeListing, !listLoading]);

    const {
      data: { CheckPaymentCodeInUse } = { CheckPaymentCodeInUse: [] },
    } = useCheckPaymentCodeInUseQuery({
      variables: {
        paymentCodeID: menu?.ID,
      },
      fetchPolicy: 'no-cache',
      skip: !menu?.ID,
    });

    const [
    PaymentCodeDelete,
    { loading: deleteLoading, error: deleteError },
  ] = usePaymentCodeDeleteMutation({})

    const [
    PaymentCodeInActive,
    { loading: activeLoading, error: activeError },
  ] = usePaymentCodeInActiveMutation({})



const handleSubmit = () => {
  PaymentCodeDelete({
    variables: {
      ID: menu?.ID,
    },
  }).then(res => {
    if (res?.data?.PaymentCodeDelete) {

      setSnackBarMsg('Delete Successfully')
      setOpenSnackBar(true)

      refetch()
      setDialog(false)

    } else {
      setSnackBarMsg('Delete Failed')
      setOpenSnackBar(true)
    }
  })
}
  
   const [dialog, setDialog] = useState<boolean>(false)
    const Dialog = (
    <CommonDialog
      fullWidth={true}
      open={dialog}
      onClose={() => setDialog(false)}
      sections={{
        header: {
          children: (
            <ListItem className="remove-padding">
              <ListItemText
                primary={
                  <>
                    <span className="xsTitle color-primary-orange flex-space">
                      {`Delete ${mode}`}
                    </span>
                  </>
                }
              />
            </ListItem>
          ),
        },
        body: () => (
          <CardContents>
            <div className="content-wrap full">
              <div className="desc">Name</div>
              <div className="xsTitle">{menu.obj?.name}</div>
            </div>
            <div className="content-wrap full">
              <div className="desc">Code</div>
              <div className="xsTitle">
                {menu.obj?.code || 'N/A'}
              </div>
            </div>
            <div className="content-wrap full">
              <div className="desc">Tax Scheme</div>
              <div className="xsTitle">{getTaxSchemeListing?.find(x => x?.id === menu.obj?.taxSchemeID)?.name || 'N/A'}</div>
            </div>
          </CardContents>
        ),
        footer: {
          actions: [
            {
              displayText: 'Cancel',
              props: {
                onClick: () => {
                  setDialog(false)
                },
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Confirm',
              props: {
                onClick: () => handleSubmit(),
                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  )

  const onClickActive = () => {
  PaymentCodeInActive({
    variables:{
      ID: menu?.ID,
      isActive: !menu?.obj?.isActive
    }
  }).then(i => {
    i.data.PaymentCodeInActive === true
      ? snackFunc('Updated sucessfully', false)
      : snackFunc('Update fail!', false)
    refetch()
    handleClose()
  })
}

  let location: any = useLocation();

  const [success, setSuccess] = useState<boolean>(
    location.state ? location.state['success'] : false,
  );


  setTimeout(() => {
    setSuccess(false);
  }, 3000);

  const [openSwitch, setOpenSwitch] = useState(false);

    const [filterSearch, setFilterSearch] = useState<string>(
    localStorage.getItem('filterValue') || ''
  )


  const {
    called: outletCalled,
    loading: outletLoading,
    error: outletError,
    data: { getOutlet } = { getOutlet: [] },
  } = useGetOutletQuery({
    fetchPolicy: 'network-only',
    variables: { ID: outletID },
  });
  return (
    <>
  
      {listLoading || deleteLoading || getAssignedOutletByUserLoading && <Loading />}

      <MainHeader
        onClick={() => {
          localStorage.removeItem('searchFilter');
          history.push({
            pathname: `/menu/outlet-app/account-journals/account-mapping`,
          });
        }}
        mainBtn="back"
        smTitle="Outlet App"
        title={getOutlet[0]?.name}
        sideBtn="switch"
        onClickAction={() => setOpenSwitch(true)}
        routeSegments={[
          { name: 'Account Journals' },
          { name: mode, current: true },
        ]}
      />

      <SearchHeader
        title={`${mode} Listing `}
        value={`${PaymentCodeListing?.length ?? 0}`}
        onChangeAction={e => {
          handleSearch(`'"${e?.target?.value}"`, ['name','code']);
          localStorage.setItem(
            `searchFilter`,
            JSON.stringify({ value: e?.target?.value }),
          );
        }}
        fixed
        search
        onCloseAction={() => handleSearch('', [])}
      />
      <ContentWrapper search>
        <List className="core-list">
          
            {!outletLoading &&
            !listLoading &&
            (PaymentCodeListing?.length === 0) ? (
              <EmptyList title="No Record found" subtitle="Add a new record now." 
              />
            ) : (
              filteredList?.map((i, index) => (
              <ListItem key={index} 
                disabled={i?.isActive === false ? true : false}>
                <ListItemText
                  primary={
                    <>
                      <span className="xsTitle">{i.name}</span>
                    </>
                  }
                  secondary={
                    <>
                      <span className="desc">
                        {i.code}
                      </span>
                    </>
                  }
                />
                <ListItemSecondaryAction style={{ top: '30px' }}>
                  <IconButton
                    edge="end"
                    onClick={e => {
                      handleClick(e, i.ID, index, i)
                    }}
                  >
                    <MoreVert />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))
          )}

        </List>

        <FloatButton
          disabled={handlePermDisabled({
            outletID: outletID,
            permEnum:
              PosPermission.AccountJournalsAccountsMappingBankTtCreate,
          })}
          onClick={() =>
            mode === 'Bank TT' ? history.push('/menu/outlet-app/account-journals/account-mapping/bank-tt/add')
          : history.push('/menu/outlet-app/account-journals/account-mapping/voucher/add')
          }
        />
        {Dialog}
      </ContentWrapper>

      <Menu
        id="menu-list"
        className="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() =>{
            localStorage.setItem('filterValue', filterSearch)
            history.push(
              mode === 'Bank TT' ? `/menu/outlet-app/account-journals/account-mapping/bank-tt/detail` 
               :`/menu/outlet-app/account-journals/account-mapping/voucher/detail`,
              {
                ...menu?.obj,
              }
            )
          }}
        >
          View
        </MenuItem>

        <MenuItem
          disabled={handlePermDisabled({
            outletID: outletID,
            permEnum: mode === 'Bank TT' ? PosPermission.AccountJournalsAccountsMappingBankTtUpdate : 
            PosPermission.AccountJournalsAccountsMappingVoucherUpdate,
          })}
          onClick={() =>
            history.push(
              mode === 'Bank TT' ? '/menu/outlet-app/account-journals/account-mapping/bank-tt/edit'
              : '/menu/outlet-app/account-journals/account-mapping/voucher/edit',
              {
                ...menu?.obj,
                TaxScheme: getTaxSchemeListing?.find(x => x?.id === menu.obj.taxSchemeID),
              }
            )
          }
        >
          Edit
        </MenuItem>
        <MenuItem
          disabled={handlePermDisabled({
            outletID: outletID,
            permEnum: mode === 'Bank TT' ? PosPermission.AccountJournalsAccountsMappingBankTtActive : 
            PosPermission.AccountJournalsAccountsMappingVoucherActive,
          })
        }
          onClick={() => {
            onClickActive()
          }}
        >
          {menu?.obj?.isActive === true ? 'Inactive' : 'Active'}
        </MenuItem>
        <MenuItem
          disabled={handlePermDisabled({
            outletID: outletID,
            permEnum: mode === 'Bank TT' ? PosPermission.AccountJournalsAccountsMappingBankTtDelete : 
            PosPermission.AccountJournalsAccountsMappingVoucherDelete,
          }) 
          || CheckPaymentCodeInUse
        }
          onClick={() => {
            setDialog(true)
            handleClose()
          }}
        >
          Delete
        </MenuItem>
      </Menu>
      <CommonDialog
        fullWidth={true}
        open={openSwitch}
        onClose={() => setOpenSwitch(false)}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <div className="session">
                    <div
                      className="title"
                      style={{ color: '#ff9800' }}
                    >{`Switch Outlet`}</div>
                  </div>
                </div>
              </div>
            ),
          },
          body: () => (
            <>
            {getAssignedOutletByUser?.length > 2 ? (
                <div className="rm-padding table-wrap sample">
                  <List
                    className="core-list content-wrap full"
                    style={{ paddingBottom: '0px' }}
                  >
                    <ListItem
                      style={{
                        boxShadow: 'none',
                        padding: '8px 12px 0px 12px',
                      }}
                    >
                      <TextField
                        id="standard-basic"
                        label="Search here..."
                        fullWidth
                        onChange={e => {
                          handleSearch1(`'"${e?.target?.value}"`, ['name']);
                        }}
                      />
                    </ListItem>
                  </List>
                </div>
              ) : null}
              <ContentWrapper
                style={{
                  marginTop: '0px',
                  width: 'inherit',
                  position: 'initial',
                  padding: '8px 0px 8px 0px',
                }}
              >
                <List>
                  {filteredList1?.map((outlet, index) => (
                    <>
                      <ListItem
                        style={{
                          backgroundColor:
                            outlet?.ID === outletID ? '#E5EDFF' : null,
                        }}
                      >
                        <div style={{ paddingRight: '6px' }}>
                          {outlet?.logo?.fileURL ? (
                            <img
                              src={outlet?.logo?.fileURL}
                              style={{
                                display: 'flex',
                                marginTop: '2px',
                                marginBottom: '2px',
                                marginRight: '4px',
                                width: '40px',
                                height: '40px',
                                justifyItems: 'center',
                                borderRadius: '30px',
                              }}
                              loading="lazy"
                            />
                          ) : (
                            <img
                              src={OutletIcon}
                              style={{
                                display: 'flex',
                                marginTop: '7px',
                                marginBottom: '8px',
                                marginRight: '4px',
                                width: '40px',
                                height: '25px',
                                justifyItems: 'center',
                                borderRadius: '30px',
                              }}
                              loading="lazy"
                            />
                          )}
                        </div>
                        <ListItemText
                          primary={
                            <span className="xsTitle">{outlet?.name}</span>
                          }
                          onClick={() => {
                            mode === 'Bank TT' ?
                            history.push( `/menu/outlet-app/account-journals/account-mapping/bank-tt`)
                            : history.push('/menu/outlet-app/account-journals/account-mapping/voucher')

                            setOpenSwitch(false);
                            localStorage.setItem('latestOutlet', outlet?.ID);
                          }}
                        />
                        {outlet?.ID === outletID ? (
                          <ListItemSecondaryAction>
                            <IconButton edge="end" aria-label="delete">
                              <Check color="primary" />
                            </IconButton>
                          </ListItemSecondaryAction>
                        ) : null}
                      </ListItem>
                      <Divider
                        style={{ display: 'flex', width: '100%' }}
                      />
                    </>
                  ))}
                </List>
              </ContentWrapper>
            </>
          ),
          
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setOpenSwitch(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  );
};
